import { FC } from 'react';

import { MessageContentTypesEnum } from '@shared/constants';

import { TelegramChatSettingsChatItemContentFactoryProps } from './types';

import styles from './TelegramChatSettingsItemContentFactory.module.css';

const { image, text } = styles;

export const TelegramChatSettingsItemContentFactory: FC<TelegramChatSettingsChatItemContentFactoryProps> = ({
  contentType,
  value,
}) => {
  switch (contentType) {
    case MessageContentTypesEnum.IMAGE: {
      return <img src={value} className={image} />;
    }
    case MessageContentTypesEnum.TEXT: {
      return <div className={text}>{value}</div>;
    }
    case MessageContentTypesEnum.VIDEO: {
      return (
        <video controls>
          <source src={value} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    default: {
      return null;
    }
  }
};
